<template>
  <div class="content-item-rating" v-if="active">
    <div class="content-item-rating__rating" v-if="!rating.persisted">
      <ThumbsRating
        v-if="ratingType === 'thumbs'"
        :contentItem="contentItem"
        :rating="rating"
        @numericRatingSaved="onNumericRatingSaved" />

      <FiveStarRating
        v-if="ratingType === '5star'"
        :contentItem="contentItem"
        :rating="rating"
        @numericRatingSaved="onNumericRatingSaved" />
    </div>

    <div class="content-item-rating__feedback" v-if="rating.persisted && !rating.feedbackPresent">
      <FeedbackRating :contentItem="contentItem" :rating="rating" @feedbackRatingSaved="onFeedbackRatingSaved"/>
    </div>
  </div>
</template>

<script>
import ThumbsRating from "components/thumbs-rating";
import FiveStarRating from "components/five-star-rating";
import FeedbackRating from "components/feedback-rating";
import { mapGetters } from "vuex";

export default {
  name: "ContentItemRating",
  components: {
    ThumbsRating,
    FeedbackRating,
    FiveStarRating
  },
  data: function () {
    return {
      contentItem: window.state.contentItem,
      rating: null
    }
  },
  props: ["inputRating"],
  computed: {
    ...mapGetters("lesson", ["lessonCompleted"]),
    ...mapGetters("exercise", ["exerciseCompleted"]),
    ratingType() {
      return this.inputRating.type;
    },
    active() {
      if(this.contentItem.contentType === "Lesson" && !this.lessonCompleted) {
        return false;
      }

      if(this.contentItem.contentType === "Exercise" && !this.exerciseCompleted) {
        return false;
      }

      if(!this.rating) {
        return false;
      }

      return this.rating.addFeedbackUrl && !this.rating.feedbackPresent;
    }
  },
  methods: {
    onFeedbackRatingSaved: function() {
      this.$destroy();

      this.$el.parentNode.removeChild(this.$el);
    },
    onNumericRatingSaved: function(contentItemRatingId, ratingValue) {
      this.$set(this.rating, "persisted", true);
      this.$set(this.rating, "id", contentItemRatingId);
      this.$set(this.rating, "value", ratingValue);
    }
  },
  mounted() {
    this.rating = this.inputRating;
  }
};
</script>
